const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']

export const getQuarterString = (d) => {
  let dateInfo = []
  if (typeof d === 'string') {
    dateInfo = d.split('-')
  } else {
    let splits = d.toLocaleDateString().split('/')
    dateInfo.push(splits[2])
    dateInfo.push(splits[1])
  }
  let year = dateInfo[0].substring(2, 4)
  let month = Number(dateInfo[1])
  if (month === 1) {
    month = 'Q1'
  } else if (month === 4) {
    month = 'Q2'
  } else if (month === 7) {
    month = 'Q3'
  } else if (month === 10) {
    month = 'Q4'
  }
  return month + year
}
// just a commit for a push

export const addDays = (days, fromDate) => {
  if (fromDate) {
    fromDate = new Date(fromDate.valueOf())
  } else {
    fromDate = new Date()
  }
  fromDate.setDate(fromDate.getDate() + days)
  return fromDate
}

export const getQuarters = function (yearsBack = 1, yearsForward = 1) {
  let d = new Date()
  let y = d.getFullYear()
  let m = d.getMonth()
  let options = []
  if (yearsBack <= 0) {
    QUARTERS.slice(parseInt(m / 3), QUARTERS.length).forEach(q => options.push(q + (y - yearsBack)))
  }
  for (let yr = y - yearsBack; yr <= y + yearsForward; yr++) {
    QUARTERS.forEach(q => options.push(q + yr))
  }
  options = options.map(f => {
    let q = f.charAt(1)
    let y = f.slice(2)
    let firstDate = new Date(y, (q - 1) * 3, 1)
    let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0)
    return {
      name: f,
      from: firstDate.toISOString().split('T')[0],
      to: endDate.toISOString().split('T')[0],
      sorting: q + y
    }
  })
  return options
}

export const isAtLeastDaysOld = function (d, daysOld) {
  const today = new Date()
  const daysFromToday = new Date(d)
  daysFromToday.setDate(daysFromToday.getDate() + daysOld)
  daysFromToday.setHours(0, 0, 0, 0)
  return today >= daysFromToday
}
export const isDaysPriorTo = function (d, days) {
  const today = new Date()
  const daysFromToday = new Date(d)
  daysFromToday.setDate(daysFromToday.getDate() - days)
  daysFromToday.setHours(0, 0, 0, 0)
  return today >= daysFromToday
}
/**
 * Want local time instead of UTC
 * @param {String} dateString the local date string to be converted to local time
 */
export const convertLocalStringToLocal = function (dateString) {
  const x = new Date(dateString)
  var userTimezoneOffset = x.getTimezoneOffset() * 60000
  return new Date(x.getTime() + userTimezoneOffset)
}

export const getLocalDateStringFormatted = function (d) {
  var options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/New_York' }
  return new Date(d).toLocaleDateString('en-US', options)
}

const stdTimezoneOffset = function (date) {
  const jan = new Date(date.getFullYear(), 0, 1)
  const jul = new Date(date.getFullYear(), 6, 1)
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
}

const isDst = function (date) {
  return date.getTimezoneOffset() < stdTimezoneOffset(date)
}

/**
 * Giving the origin timezone, nad the current laptops timezone
 * this will condition the timezone to the correct date
 * @param {*} d
 */
export const correctToUTCTime = function (d) {
  const now = new Date()
  let dat = new Date(d)
  let currentHoursOffset = now.getTimezoneOffset() / 60
  let timeHoursOffset = dat.getTimezoneOffset() / 60
  dat.setHours(dat.getHours() + (currentHoursOffset - timeHoursOffset + (!isDst(dat) && isDst(now) ? 1 : 0)))
  return dat
}

export const getCurrentDate = function () {
  let d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

export const addDaysToDate = function (d, days) {
  const copiedDate = new Date(d)
  copiedDate.setDate(d.getDate() + days)
  return copiedDate
}

export const addMonthsToDate = function (d, months) {
  const copiedDate = new Date(d)
  copiedDate.setMonth(d.getMonth() + months)
  return copiedDate
}

export const isSameDay = function (day1, day2) {
  let oldDate = new Date(day1)
  let newdata = new Date(day2)
  return oldDate.getFullYear() === newdata.getFullYear() && oldDate.getMonth() === newdata.getMonth() && oldDate.getDate() === newdata.getDate()
}

export const isInTheFuture = function (d) {
  const today = new Date()
  return d && (d === '' || today < new Date(d))
}

export const isInDaysRangeFromToday = function (d, days) {
  if (!d) return false
  let dat = new Date(d)
  let today = new Date()
  const diffTime = Math.abs(today - dat)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return days >= diffDays
}

export const getCampaignQuarters = function () {
  function getQuarterString (quarterNumber) {
    return quarterNumber + 'Q'
  }

  let d = new Date()
  let y = d.getFullYear() % 100
  let previousYear = y - 1 === -1 ? '00' : y - 1
  let nextYear = y + 1 === 100 ? '00' : y + 1
  y = ('0' + y).slice(-2)
  let m = d.getMonth()
  let options = []
  let currentQuarter = parseInt(m / 3) + 1
  // Get the next quarter
  let q = (currentQuarter % 4) + 1
  if (q < currentQuarter) {
    options.push(getQuarterString(q) + nextYear)
  } else {
    options.push(getQuarterString(q) + y)
  }
  // Current quarter
  options.push(getQuarterString(currentQuarter) + y)

  // Previous quarters
  for (let i = 2; i <= 5; i++) {
    let q = ((currentQuarter - i + 16) % 4) + 1
    if (q >= currentQuarter) {
      options.push(getQuarterString(q) + previousYear)
    } else {
      options.push(getQuarterString(q) + y)
    }
  }
  options = options.map(f => {
    return {
      name: f,
      value: f,
    }
  })
  return options
}



// WEBPACK FOOTER //
// ./src/app/common/U_D.js